<template>
  <van-nav-bar
    :title="title"
    left-arrow
    fixed
    placeholder
    class="aroma-secondary-nav"
    @click-left="goBack"
  />
</template>

<script>
import { NavBar } from 'vant'

export default {
  name: 'AromaSecondaryNav',

  components: {
    [NavBar.name]: NavBar
  },

  props: {
    title: {
      type: String,
      required: true
    },
    fallback: {
      type: String,
      default: ''
    }
  },

  methods: {
    goBack () {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      if (this.fallback) {
        this.$router.replace({
          name: this.fallback,
          query: { sn: this.$route.query.sn || '' }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.aroma-secondary-nav {
  z-index: 20;
  border-bottom: 1px solid #eceef2;

  ::v-deep .van-nav-bar__title {
    color: #24304a;
    font-size: 17px;
    font-weight: 600;
  }

  ::v-deep .van-icon {
    color: #596afd;
  }
}
</style>
